require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

module.exports = formatBasic;

function formatBasic(code) {
  return '&#x' + code.toString(16).toUpperCase() + ';';
}